// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./Messages.module.css";
// CSS
// Models
import { I_NotificationMain } from "../../../Models/interfaces";
// Models
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Services
import { getUserNotifications } from "../../../Services/Profile/get/getUSerNotifications";
// Services
// Images
import { quiz_jame_header } from "../../../Images/images";
import MessageCard from "./MessageCard/MessageCard";
import { Fade } from "react-awesome-reveal";
import PendingManager from "../../../Components/PendingManager/PendingManager";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// Images

const Messages = () => {
  const [tickets, setTickets] = useState<I_NotificationMain[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  //
  const userToken = useContext(UserTokenContext);

  const navigate = useNavigate();
  useEffect(() => {
    getUserNotifications(userToken)
      .then(
        ({
          data: {
            data: { data },
          },
        }) => {
          setTickets(data);
          setIsPending(false);
        }
      )
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken]);
  return (
    <div className={`${styles.messagesMainContainer} overflow-y-scroll`}>
      <img src={quiz_jame_header} alt="" className="w-full h-48" />
      <div className="flex items-center justify-between w-full relative">
        <h1 className="w-full text-center mt-4">پیــــام ها</h1>
        <BiArrowBack
          className="absolute left-3 top-1/2 text-2xl"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>
      <PendingManager
        isPending={isPending}
        data={
          <div className={`${styles.messagesContainer} mx-4 pb-6`}>
            {tickets.map((item) => (
              <Fade key={item.id} triggerOnce>
                <MessageCard data={item} />
              </Fade>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default Messages;
